import React, { useRef } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Products from "../components/Products";
import Industries from "../components/Industries";
import WhyCopperX from "../components/WhyCopperX";
import Standards from "../components/Standards";
import QuoteForm from "../components/QuoteForm";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  const quoteRef = useRef(null);

  const scrollToQuote = () => {
    quoteRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="bg-white text-[#0F172A]" data-testid="home-page">
      <Navbar onQuoteClick={scrollToQuote} />
      <Hero onQuoteClick={scrollToQuote} />
      <About />
      <Products onQuoteClick={scrollToQuote} />
      <Industries />
      <WhyCopperX />
      <Standards />
      <QuoteForm ref={quoteRef} />
      <Contact />
      <Footer />
    </div>
  );
}
